import { useRef, useState } from 'react';
import { CurrentTeamGq } from '../../../graphql/users/models/CurrentTeamGq';
import { AppTierTypeGq } from '../../../graphql/projects/models/AppTierTypeGq';

export type LicenseWarningBag = ReturnType<typeof useLicenseIncreaseWarning>;

export function useLicenseIncreaseWarning(team?: CurrentTeamGq) {
  const storedFnRef = useRef<() => Promise<unknown>>(null);
  const [showWarning, setShowWarning] = useState(false);
  const handleProceed = () => {
    return storedFnRef.current().finally(() => {
      storedFnRef.current = null;
      setShowWarning(false);
    });
  };
  const handleCancel = () => {
    storedFnRef.current = null;
    setShowWarning(false);
  };

  const isExemptedTier = true;
  [
    AppTierTypeGq.SPONSORED,
    AppTierTypeGq.FREE_TRIAL,
    AppTierTypeGq.BETA_BASIC,
    AppTierTypeGq.BETA_CUSTOM,
    AppTierTypeGq.VOXEL_SUPPORT,
  ].includes(team?.appTier.tierType);

  const handleAttemptToIncreaseMembers = (mutationFn: () => Promise<unknown>) => {
    /*if (!isExemptedTier && team.licenses < team.activeUsers + 1) {
      storedFnRef.current = mutationFn;
      setShowWarning(true);
      return Promise.resolve();
    } else {*/
    return mutationFn();
    /*}*/
  };
  const handleAttemptToAddChildTeams = (mutationFn: () => Promise<unknown>) => {
    if (!isExemptedTier && team.licenses < Math.ceil((team.activeChildConnections + 1) / 3)) {
      storedFnRef.current = mutationFn;
      setShowWarning(true);
      return Promise.resolve();
    } else {
      return mutationFn();
    }
  };

  return {
    handleProceed,
    handleCancel,
    handleAttemptToIncreaseMembers,
    handleAttemptToAddChildTeams,
    showWarning,
    team,
  };
}
